/**
 * 순서 목록(.order-list) — 화살표로 항목을 한 칸씩 옮긴다.
 *
 * 번호는 CSS 카운터가 세므로 DOM 순서만 바꾸면 된다. 맨 위의 ↑ · 맨 아래의 ↓ 는 비활성으로 둔다.
 * 옮긴 뒤에도 같은 화살표에 포커스를 두어 키보드로 계속 옮길 수 있게 하고,
 * 끝에 닿아 그 화살표가 막히면 반대쪽 화살표로 넘긴다.
 *
 * 저장은 각 화면 모듈이 readOrder(list) 로 ID 순서를 읽어 한다(매장 소식: initPartnerNews.js).
 * 버튼이 흩어져 있지 않지만 목록이 여러 개일 수 있어 문서 한 곳에서 위임으로 받는다.
 */

const ITEM = '.order-list__item';

/** 맨 끝 화살표를 막는다 */
const syncEdges = (list) => {
  const items = Array.from(list.querySelectorAll(`:scope > ${ITEM}`));

  items.forEach((item, index) => {
    const up = item.querySelector('[data-order-move="up"]');
    const down = item.querySelector('[data-order-move="down"]');

    if (up) {
      up.disabled = 0 === index;
    }

    if (down) {
      down.disabled = items.length - 1 === index;
    }
  });
};

/**
 * 지금 보이는 순서대로 항목 ID 를 읽는다.
 *
 * @param {HTMLElement} list
 * @return {number[]}
 */
const readOrder = (list) =>
  Array.from(list.querySelectorAll(`:scope > ${ITEM}[data-id]`)).map((item) => Number(item.dataset.id));

const InitOrderList = () => {
  const lists = document.querySelectorAll('[data-order-list]');

  if (0 === lists.length) {
    return;
  }

  lists.forEach(syncEdges);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-order-move]');
    const item = button?.closest(ITEM);
    const list = item?.parentElement;

    if (!button || !item || !list?.matches('[data-order-list]')) {
      return;
    }

    const up = 'up' === button.dataset.orderMove;
    const sibling = up ? item.previousElementSibling : item.nextElementSibling;

    if (!sibling) {
      return;
    }

    if (up) {
      sibling.before(item);
    } else {
      sibling.after(item);
    }

    syncEdges(list);

    // 노드를 옮기면 포커스가 풀린다 — 같은 화살표로, 막혔으면 반대쪽으로 되돌린다
    const opposite = item.querySelector(`[data-order-move="${up ? 'down' : 'up'}"]`);
    (button.disabled ? opposite : button)?.focus();

    // 방금 옮긴 줄을 잠깐 표시한다 (클래스를 빼면 CSS 가 천천히 되돌린다)
    item.classList.add('order-list__item--moved');
    window.clearTimeout(Number(item.dataset.movedTimer || 0));
    item.dataset.movedTimer = String(window.setTimeout(() => item.classList.remove('order-list__item--moved'), 150));
  });
};

export { readOrder, syncEdges };
export default InitOrderList;
